<script setup lang="ts">
const props = defineProps<{
  linkClass?: string
  href?: string
  condition?: boolean
}>()
</script>

<template>
  <div>
    <a
      v-if="props.condition"
      :class="props.linkClass"
      :href="props.href"
    >
      <slot />
    </a>

    <slot v-if="!props.condition" />
  </div>
</template>
